export const physics12 = [
  {
    id: 'phy121',
    image: require('../assets/images/simulation/phy/12/meter-bridge.jpg'),
    name: 'Determine the specific resistance of a wire using a meter bridge.',
    title: 'Current Electricity - Wheatstone Bridge',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy122',
    image: require('../assets/images/simulation/phy/12/concavelens.jpg'),
    name: 'Determine focal length and power of a convex lens.',
    title: 'Reflection of Light - Convex Lens',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy123',
    image: require('../assets/images/simulation/phy/12/potentiometer.jpg'),
    name: 'Comparison of EMF of two cells using a potentiometer.',
    title: 'Current Electricity - Potentiometer',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy124',
    image: require('../assets/images/simulation/phy/12/ohms-law.jpg'),
    name: "Verification of Ohm's law and resistance laws.",
    title: "Current Electricity - Ohm's law",
    route: '/physics-simulation-template',
  },
];

export const physics11 = [
  {
    id: 'phy111',
    image: require('../assets/images/simulation/phy/11/sphero-meter.jpg'),
    name: 'Determine radius of curvature of a convex and concave surface using spherometer.',
    title: 'Optics - Spherometer',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy112',
    image: require('../assets/images/simulation/phy/11/youngs-modulus.jpg'),
    name: "Determine Young's modulus of a wire using Vernier scale.",
    title: "Mechanics - Young's modulus",
    route: '/physics-simulation-template',
  },
  {
    id: 'phy113',
    image: require('../assets/images/simulation/phy/11/helical-spring.jpg'),
    name: 'Determine spring constant of a helical spring.',
    title: 'Mechanics - Helical Spring',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy114',
    image: require('../assets/images/simulation/phy/11/sonometer.jpg'),
    name: "Determine frequency of tuning fork using Melde's experiment.",
    title: 'Waves - Tuning Fork Frequency',
    route: '/physics-simulation-template',
  },
];

export const physics10 = [
  {
    id: 'phy101',
    image: require('../assets/images/simulation/phy/10/vernier-calliper.jpg'),
    name: 'Determine area and volume of a rectangular block.',
    title: 'Physical Quantities - Slide Calipers',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy102',
    image: require('../assets/images/simulation/phy/10/screwguage.jpg'),
    name: 'Determine cross-sectional area of a circular wire.',
    title: 'Physical Quantities - Screw Gauge',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy103',
    image: require('../assets/images/simulation/phy/10/concave-mirror.jpg'),
    name: 'Creation and display of image using convex lens.',
    title: 'Reflection of Light - Convex Lens',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy104',
    image: require('../assets/images/simulation/phy/10/inclinedplane.jpg'),
    name: 'Determine average speed by rolling a marble on an inclined plane.',
    title: 'Motion - Inclined Plane',
    route: '/physics-simulation-template',
  },
];

export const physics09 = [
  {
    id: 'phy091',
    image: require('../assets/images/simulation/phy/09/density-of-solid.jpg'),
    name: 'Measure force applied on an object using spring balance.',
    title: 'State of Matter - Relative Density',
    route: '/physics-simulation-template',
  },
  {
    id: 'phy092',
    image: require('../assets/images/simulation/phy/09/newtons-second-law.jpg'),
    name: "Proof of Newton's second law of motion.",
    title: "Motion - Newton's Second Law",
    route: '/physics-simulation-template',
  },
];
